import styled from 'styled-components';
import { themeColor } from '../theme/colors';
import { smBold, xsBold } from '../theme/typography';


const Label = styled.span`
  color: ${themeColor('textTertiary')};
  ${xsBold}
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  color: ${themeColor('gray')};
  cursor: pointer;
  display: flex;
  padding: 0;

  &:hover {
    color: ${themeColor('textPrimary')};
  }
`;

const Content = styled.button`
  background: none;
  border: none;
  color: ${themeColor('textPrimary')};
  cursor: pointer;
  ${smBold};

  .serviceCounter {
    margin-left: var(--space-50);
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 36px;

  background: ${themeColor('buttonBackground')};
  border: 1px solid ${themeColor('strokePrimary')};
  border-radius: 8px;

  padding: 0 8px 0 16px;
  gap: 8px;

  & ${Label} {
    &:has(+ ${Content}) {
      margin-right: 6px;
    }
  }

  & ${Label} + ${Content} {
    padding: 0;
    padding-left: 14px;

    height: 100%;
    max-width: 180px;

    border-left: 1px solid ${themeColor('strokePrimary')};
  }
`;


export default {
  Label,
  ClearButton,
  Content,
  Container,
};
